import { Model } from './model';

export class Systemlogs extends Model {
  content: string;
  systemStatus: number;
  systemtType: number;
}
